// extracted by mini-css-extract-plugin
export default {"feed":"feed_feed__jUzVZ","items":"feed_items__hkdr0","done":"feed_done__zdh2N","numbers":"feed_numbers__ceWcS","table":"feed_table__6EEYK"};